import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminRepository } from 'repositories/AdminRepository';
import { IAdminUsersState } from 'store/slices/adminUsersSlice';
import { IAuthState } from 'store/slices/authSlice';
import { IAdminUser, TAdminUsersQuery } from 'types';
import { EApiResponseStatus, IApiResponseDetails } from 'types/api';

export const fetchUsers = createAsyncThunk<
  { content: IAdminUser[]; details: IApiResponseDetails },
  void,
  { state: { auth: IAuthState; adminUsers: IAdminUsersState } }
>('adminUsers/fetchUsers', async (_, { getState }) => {
  const {
    auth: { token },
    adminUsers: {
      currentPage,
      itemsPerPage,
      sortBy,
      sortDir,
      search,
      vip,
      weeklyFrom,
      weeklyTo,
      dailyFrom,
      dailyTo,
      createdFromDate,
      createdToDate,
      updatedFromDate,
      updatedToDate,
    },
  } = getState();
  if (!token) throw Error('no token');

  const params: TAdminUsersQuery = {
    page: String(currentPage),
    size: String(itemsPerPage),
  };
  if (sortBy) {
    params.sort = sortDir ? `users.${sortBy},${sortDir.toLowerCase()}` : sortBy;
  }
  if (search) params.filter = search;
  if (createdFromDate) params.createdfrom = createdFromDate;
  if (createdToDate) params.createdto = createdToDate;
  if (updatedFromDate) params.updatedfrom = updatedFromDate;
  if (updatedToDate) params.updatedto = updatedToDate;
  if (vip) params.vip = vip;
  if (weeklyFrom) params.weeklyfrom = weeklyFrom;
  if (weeklyTo) params.weeklyto = weeklyTo;
  if (dailyFrom) params.dailyfrom = dailyFrom;
  if (dailyTo) params.dailyto = dailyTo;

  const adminUsersResponse = await AdminRepository.getUsers(token, params);

  if (adminUsersResponse.status === EApiResponseStatus.FAILURE) {
    throw Error(adminUsersResponse.error);
  }

  return adminUsersResponse.data;
});

export const fetchExportUsers = createAsyncThunk<
  { exportData: string },
  void,
  { state: { auth: IAuthState } }
>('adminUsers/fetchExportUsers', async (_, { getState }) => {
  const {
    auth: { token },
  } = getState();

  if (!token) throw Error('no token');

  const adminExportUsersResponse = await AdminRepository.getUsersExport(token);

  if (adminExportUsersResponse.status === EApiResponseStatus.FAILURE) {
    throw Error(adminExportUsersResponse.error);
  }

  return {
    exportData: adminExportUsersResponse.data,
  };
});
